/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { KPIGradeFilterDto, ReportService, SeasonDto, SeasonService } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import UseSeason from 'app/modules/core/hooks/season/UseSeason'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'



const KpiSummaryPage: FC = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const navigate = useNavigate()     
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<string[][]>([])
    const [footData, setFootData] = useState<string[][]>([])
    const [season, setSeason] = useState<SeasonDto[]>()
    const [searchParam, setSearchParam] = useState<KPIGradeFilterDto>({
        page: 0,
        length: 10,
        seasonId: lastSeason?.id
    })

    useMemo(() => {
        SeasonService.GetActiveSeasons().then(res => {
          setSeason(res.data.result)
          if(res.data.result.length > 0){
            setSearchParam({
                ...searchParam,
                seasonId:res.data.result[0].id
              })
          }
         
        })
      }, [])

    const columnDef: ColDef<string[][]>[] = [
        {
            label: 'ลำดับ',
            renderItem: ({item, index}) => item[index],
          
        },
        {
            label: 'ชื่อ นามสกุล',
            renderItem: ({item, index}) => item[index],
        },
        {
            label: 'รหัสพนักงาน',
            renderItem: ({item, index}) => item[index],
        },
        {
            label: 'ประเภท',
            renderItem: ({item, index}) => item[index],
            filterOption: [
                { value: 'FullTime', label: 'FullTime' },
                { value: 'PartTime', label: 'PartTime' },
            ],
        },
        {
            label: 'มาสาย',
            renderItem: ({item, index}) => item[index]
        },
        {
            label: 'ลา',
            renderItem: ({item, index}) => item[index]
        },
        {
            label: 'เขียนแฟ้ม',
            renderItem: ({item, index}) => item[index]

        },
        {
            label: 'ลงบันทึกสถิติ',
            renderItem: ({item, index}) => item[index]
        },

        {
            label: 'คะแนนกิจกรรมพิเศษ',
            renderItem: ({item, index}) => item[index]
        },
        {
            label: 'JobAssignment',
            renderItem: ({item, index}) => item[index]
        },
        {
            label: 'จำนวนผู้ป่วย',
            renderItem: ({item, index}) => item[index]
        },

        {
            label: 'ชม ทำงาน',
            renderItem: ({item, index}) => item[index]
        },

        {
            label: 'รายได้',
            renderItem: ({item, index}) => item[index]
        },
        {
            label: 'คะแนนรวม',
            renderItem: ({item, index}) => item[index]
        },
        {
            label: 'เกรด',
            renderItem: ({item, index}) => item[index]
        }

    ]


    const tableSetting: TableSetting<string[][]> = {
        showColAction: false,
        primaryKey: (item: string[][]) => item,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: false,
        showFilter: true,
        showSearch: true,
        showBtnExport:true,
        btnAddText: 'เพิ่มสถิติ',
        searchTextValue: '',
        onBtnAddClick: () => navigate('/stat-detail/new'),
        onSearchTextChange: (e: any) => {
            e.preventDefault()
            if (e.target.value.length > 0) {
                setSearchParam((s) => ({ ...s, searchText: e.target.value, page: 1 }))
                //setPageSetting((s) => ({...s, currentPage: 1}))
            }
            if (e.target.value.length === 0) {
                setSearchParam((s) => ({ ...s, searchText: '', page: 1 }))
                //setPageSetting((s) => ({...s, currentPage: 1}))
            }
        },
        onFilterApply: (val: { label: string; value: any }[]) => {
            const worktype = val.find((x) => x.label === 'ประเภท')?.value
            setSearchParam((s) => ({
                ...s,
                workingTypeCode: worktype ? worktype : undefined,

            }))
        },
        onExportClick(e) {
            //ReportService.Export(searchParam).then((res)=>{});  
            const API_URL = process.env.REACT_APP_API_URL          
            window.open(`${API_URL}/reports/kpi-summarise/export?seasonId=${searchParam.seasonId}`, '_blank');
          

        },
    }

    useEffect(() => {
        const load = () => {
            ReportService.GetKPISummary(searchParam).then((result) => {
                const row = result.data.result
                setData(row.rows)
                setFootData(row.footers)
            })
        }
        load()
    }, [searchParam,reload])

    const onSelectSeason = useCallback((seasonid: number) => {        
        setSearchParam((s) => ({ ...s, seasonId:seasonid, page: 1 }))
      }, [])
      
    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>
                <div className='card-header'>
                <h3 className='fw-bolder p-5 d-flex justify-content-between'><span className='pe-5'>เลือก Season</span> <span>
                <select className='form-control select' onChange={(e) =>
                  e.target?.value && onSelectSeason(Number(e.target.value))}
                  value={searchParam.seasonId} >
                  {season?.map((item, index) => {
                    return <option key={index} value={item.id}>{item.title}</option>
                  })}
                </select>
              </span></h3>
                </div>
                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            data={data as []}

                        />
                        {/* end::Table */}
                    </div>

                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}
export { KpiSummaryPage }
